import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
        initStatsToggle();
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1200px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'grid-attorney': 'team-carousel',
    'grid-videos': 'videos-carousel',
    'our-team': 'team-sidebar-widget',
    'services-slider': 'services-slider',
    'portfolio-slider': 'portfolio-slider',
    'podcast-headlines-slider': 'headlines-carousel',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

/**
 * Stats Section Toggle
 */
const statsToggle = document.querySelector('.stats__toggle-input');
const beforeCases = document.querySelector('.stats__cases--before');
const afterCases = document.querySelector('.stats__cases--after');

if (statsToggle && beforeCases && afterCases) {
    // Initialize with After cases showing (since checkbox is checked by default)
    beforeCases.style.display = 'none';
    afterCases.style.display = 'flex';

    statsToggle.addEventListener('change', () => {
        if (statsToggle.checked) {
            beforeCases.style.display = 'none';
            afterCases.style.display = 'flex';
        } else {
            beforeCases.style.display = 'flex';
            afterCases.style.display = 'none';
        }
    });
}

/**
 * Re-initialize video lightbox after load more
 */
const loadMoreBtns = document.querySelectorAll('.page-template-videos .load-more');

if (loadMoreBtns.length) {
    // Function to initialize video lightbox
    const initVideoLightbox = () => {
        const videoLinks = document.querySelectorAll('.cw_video_open_popup, .cw_video_open_popup_customized');
        
        videoLinks.forEach(link => {
            const videoHeight = link.getAttribute('video_height') || 400;
            const videoWidth = link.getAttribute('video_width') || 600;

            // Adjust dimensions for mobile
            let finalWidth = videoWidth;
            let finalHeight = videoHeight;
            
            if (window.innerWidth <= 700 || window.innerWidth <= videoWidth) {
                const ratio = 0.85;
                finalWidth = Math.round(window.innerWidth * ratio);
                finalHeight = Math.round(finalWidth * 0.565);
            }
            
            // Initialize colorbox
            if (typeof jQuery !== 'undefined') {
                jQuery(link).colorbox({
                    iframe: true,
                    innerWidth: finalWidth,
                    innerHeight: finalHeight
                });
            }
        });
    };

    // Initialize on load more click for each button
    loadMoreBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            // Small delay to ensure new content is loaded
            setTimeout(initVideoLightbox, 500);
        });
    });

    // Initial call
    initVideoLightbox();
}

/**
 * Services page: sticky sidebar-holder (JS fallback when CSS sticky fails)
 */
function initServicesSidebarSticky() {
    if (!document.body.classList.contains('page-template-services')) return;

    const sidebarHolder = document.querySelector('.page-template-services .main-content .sidebar .sidebar-holder');
    if (!sidebarHolder) return;

    const DESKTOP_MIN = 992;
    const STICKY_TOP = 100;
    const STICKY_TOP_LARGE = 120;
    const LARGE_MIN = 1200;

    let wrapper = null;
    let ticking = false;
    let isStuck = false;

    function getStickyTop() {
        return window.innerWidth >= LARGE_MIN ? STICKY_TOP_LARGE : STICKY_TOP;
    }

    function wrapSidebar() {
        if (sidebarHolder.parentElement.classList.contains('sticky-sidebar-holder-wrapper')) return;
        wrapper = document.createElement('div');
        wrapper.className = 'sticky-sidebar-holder-wrapper';
        sidebarHolder.parentNode.insertBefore(wrapper, sidebarHolder);
        wrapper.appendChild(sidebarHolder);
    }

    function stick() {
        if (isStuck) return;
        isStuck = true;
        const rect = sidebarHolder.getBoundingClientRect();
        wrapper.style.height = `${rect.height}px`;
        sidebarHolder.classList.add('is-sticky');
        sidebarHolder.style.top = `${getStickyTop()}px`;
        sidebarHolder.style.left = `${rect.left}px`;
        sidebarHolder.style.width = `${rect.width}px`;
    }

    function unstick() {
        if (!isStuck) return;
        isStuck = false;
        sidebarHolder.classList.remove('is-sticky');
        sidebarHolder.style.top = '';
        sidebarHolder.style.left = '';
        sidebarHolder.style.width = '';
        wrapper.style.height = '';
    }

    function update() {
        if (window.innerWidth < DESKTOP_MIN) {
            unstick();
            ticking = false;
            return;
        }
        const awardsPart = document.getElementById('awards-part');
        const stickyBottom = getStickyTop() + sidebarHolder.offsetHeight;
        const reachedAwards = awardsPart && awardsPart.getBoundingClientRect().top <= stickyBottom;

        if (isStuck) {
            const wrapperRect = wrapper.getBoundingClientRect();
            if (wrapperRect.top >= getStickyTop() || reachedAwards) {
                unstick();
            } else {
                sidebarHolder.style.left = `${wrapperRect.left}px`;
                sidebarHolder.style.width = `${wrapperRect.width}px`;
            }
        } else if (!reachedAwards) {
            // Only stick when sidebar reaches threshold AND we haven't passed #awards-part
            const rect = sidebarHolder.getBoundingClientRect();
            if (rect.top <= getStickyTop()) {
                stick();
            }
        }
        ticking = false;
    }

    function onScrollOrResize() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    }

    wrapSidebar();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    update();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServicesSidebarSticky);
} else {
    initServicesSidebarSticky();
}



